var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecoration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 320,
    height: 302,
    viewBox: "0 0 320 302",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddi_191_2091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.485 201.682C148.783 201.682 138.299 197.728 130.21 190.41C128.414 188.784 128.281 186.019 129.906 184.222C131.532 182.426 134.297 182.293 136.094 183.918C144.42 191.455 155.939 194.525 166.898 192.121C174.778 190.391 181.849 185.952 186.811 179.612C193.236 171.41 195.64 160.879 193.407 150.718C192.342 145.871 190.318 141.413 187.39 137.469C184.558 133.648 181.032 130.502 176.897 128.107C174.806 126.89 174.093 124.21 175.31 122.119C176.527 120.028 179.207 119.315 181.298 120.532C186.459 123.535 190.879 127.48 194.424 132.251C198.093 137.203 200.63 142.782 201.961 148.846C204.755 161.573 201.742 174.756 193.701 185.021C187.485 192.957 178.627 198.517 168.771 200.684C165.701 201.35 162.583 201.682 159.485 201.682Z",
    fill: "#DB3EB1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ddi_191_2091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.58 223.685C152.565 223.685 145.551 222.564 138.803 220.34C133.813 218.695 129.041 216.471 124.612 213.734C116.229 208.544 108.987 201.397 103.664 193.052C97.1819 182.891 93.5796 171.191 93.247 159.206C93.0284 151.545 94.1499 143.932 96.5736 136.594C99.387 128.059 103.797 120.332 109.671 113.631C117.769 104.393 128.281 97.5968 140.057 93.9565C142.367 93.2436 144.819 94.5363 145.532 96.8459C146.245 99.1555 144.952 101.608 142.643 102.321C132.416 105.476 123.291 111.378 116.258 119.4C111.163 125.217 107.333 131.918 104.89 139.332C102.79 145.709 101.82 152.315 102.001 158.959C102.295 169.357 105.422 179.517 111.049 188.337C115.668 195.58 121.951 201.787 129.222 206.282C133.062 208.658 137.206 210.588 141.54 212.014C151.853 215.416 162.849 215.834 173.343 213.24C184.72 210.426 194.832 204.315 202.598 195.58C205.212 192.643 207.521 189.421 209.479 186.009C211.399 182.654 212.996 179.061 214.222 175.354C219.031 160.755 217.872 145.148 210.952 131.424C209.859 129.266 210.734 126.633 212.891 125.54C215.049 124.457 217.682 125.322 218.775 127.479C226.749 143.295 228.089 161.278 222.548 178.101C221.141 182.369 219.307 186.503 217.083 190.371C214.83 194.306 212.159 198.023 209.146 201.406C200.203 211.462 188.55 218.496 175.443 221.746C170.234 223.039 164.902 223.685 159.58 223.685Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ddi_191_2091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.724 192.947C262.315 192.947 261.897 192.89 261.479 192.767C259.16 192.082 257.829 189.649 258.513 187.33C262.762 172.921 263.789 157.419 261.479 142.506C259.188 127.717 253.609 113.336 245.34 100.933C237.004 88.4343 226.236 78.0933 213.309 70.1949C203.292 64.074 192.437 59.7399 181.06 57.3067C158.021 52.3928 133.718 55.5863 112.646 66.3171C102.752 71.3545 93.8077 77.9032 86.0424 85.792C84.3506 87.5124 81.5752 87.5409 79.8454 85.8396C78.125 84.1382 78.0965 81.3724 79.7979 79.6426C88.219 71.0789 97.9422 63.9599 108.673 58.5043C131.532 46.8706 157.897 43.4014 182.895 48.7335C195.241 51.3663 207.008 56.0711 217.881 62.7148C231.9 71.2785 243.591 82.5034 252.64 96.0666C261.612 109.525 267.666 125.122 270.147 141.166C272.647 157.352 271.535 174.176 266.925 189.811C266.364 191.712 264.615 192.947 262.724 192.947Z",
    fill: "#2CD5C4"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ddi_191_2091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.474 254.338C102.695 254.338 101.906 254.128 101.193 253.691C82.8298 242.476 68.1927 226.356 58.8592 207.081C51.8542 192.624 47.9763 176.504 47.6437 160.441C47.5962 158.027 49.5161 156.022 51.9303 155.974C51.9588 155.974 51.9968 155.974 52.0253 155.974C54.4015 155.974 56.3499 157.875 56.407 160.261C56.7206 175.069 60.2944 189.934 66.748 203.26C75.3497 221.024 88.8463 235.87 105.765 246.211C107.827 247.475 108.483 250.165 107.219 252.237C106.392 253.596 104.947 254.338 103.474 254.338Z",
    fill: "#AC4FC6"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_ddi_191_2091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.912 263.034C196.144 263.034 194.481 261.96 193.815 260.212C192.95 257.949 194.091 255.421 196.353 254.556C208.205 250.042 218.983 243.474 228.384 235.043C230.18 233.427 232.955 233.58 234.571 235.385C236.187 237.191 236.035 239.957 234.229 241.573C224.021 250.726 212.33 257.845 199.47 262.749C198.957 262.939 198.425 263.034 197.912 263.034Z",
    fill: "#DB3EB1"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_ddi_191_2091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.98 237.676C267.125 237.676 266.269 237.429 265.509 236.906C263.513 235.538 263 232.81 264.368 230.814C276.914 212.508 284.395 191.075 286.01 168.815C287.065 154.225 285.63 139.75 281.724 125.788C276.506 107.111 266.821 89.5939 253.733 75.1373C239.799 59.7493 222.149 47.9541 202.702 41.0347C192.057 37.2519 180.889 34.9042 169.512 34.0868C160.226 33.412 150.893 33.7542 141.768 35.1133C124.166 37.7271 107.608 43.9431 92.5531 53.5808C82.3451 60.12 73.1351 68.0754 65.1893 77.2379C63.602 79.0628 60.8361 79.2623 59.0112 77.6751C57.1864 76.0878 56.9868 73.3219 58.574 71.4971C67.0712 61.7073 76.9085 53.1911 87.8293 46.2052C103.93 35.8927 121.647 29.249 140.475 26.4546C150.237 25.0099 160.217 24.6392 170.139 25.3521C182.305 26.236 194.243 28.7357 205.63 32.7847C226.435 40.1888 245.312 52.8015 260.215 69.254C274.215 84.7085 284.566 103.442 290.154 123.43C294.327 138.362 295.867 153.845 294.736 169.442C293.006 193.251 285.003 216.177 271.582 235.766C270.746 237.011 269.377 237.676 267.98 237.676Z",
    fill: "#DB3EB1"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_ddi_191_2091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.9293 276.807C94.1784 276.807 93.4276 276.617 92.7337 276.208C75.3688 266.104 60.2089 251.952 48.8888 235.281C40.2396 222.535 33.8905 208.544 30.0126 193.698C27.9501 185.79 26.61 177.645 26.0302 169.49C25.5645 163.036 25.574 156.459 26.0492 149.958C26.2203 147.544 28.3208 145.728 30.735 145.909C33.1492 146.08 34.9646 148.18 34.784 150.595C34.3468 156.678 34.3373 162.827 34.7745 168.863C35.3162 176.495 36.5708 184.108 38.5003 191.493C42.1215 205.37 48.0524 218.458 56.1504 230.377C66.7385 245.974 80.91 259.204 97.1534 268.652C99.2444 269.868 99.9572 272.549 98.7406 274.64C97.9137 276.027 96.4405 276.807 94.9293 276.807Z",
    fill: "#2CD5C4"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_ddi_191_2091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.504 247.295C152.309 247.295 145.133 246.42 138.061 244.671C125.182 241.487 113.473 235.661 103.255 227.354C101.383 225.824 101.098 223.067 102.618 221.195C104.139 219.313 106.905 219.037 108.777 220.558C117.987 228.048 128.547 233.294 140.162 236.165C149.125 238.379 158.278 239.045 167.374 238.142C189.709 235.927 210.268 224.351 223.755 206.368C230.228 197.738 234.837 188.005 237.451 177.436C240.778 163.987 240.578 149.863 236.871 136.604C232.67 121.577 224.278 108.175 212.587 97.8534C202.978 89.3658 191.268 83.2448 178.732 80.1463C172.401 78.578 165.919 77.7891 159.466 77.7796C159.437 77.7796 159.409 77.7796 159.38 77.7796C137.196 77.7796 115.773 87.1227 100.584 103.433C91.3365 113.355 84.7212 125.616 81.4421 138.866C80.8624 141.214 78.4862 142.649 76.1386 142.069C73.7909 141.489 72.3557 139.113 72.9355 136.765C76.5663 122.071 83.9133 108.48 94.1688 97.4637C111.011 79.3859 134.773 69.0164 159.38 69.0164C159.409 69.0164 159.437 69.0164 159.475 69.0164C166.632 69.0259 173.818 69.9098 180.832 71.6396C194.737 75.0803 207.721 81.8666 218.385 91.2857C231.349 102.729 240.654 117.585 245.311 134.247C249.417 148.96 249.646 164.623 245.958 179.536C243.059 191.255 237.945 202.053 230.76 211.624C215.8 231.555 193.008 244.396 168.238 246.858C165.33 247.152 162.422 247.295 159.504 247.295Z",
    fill: "#AC4FC6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddi_191_2091",
    x: 103.971,
    y: 95.1386,
    width: 123.809,
    height: 131.343,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.3996
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.858824 0 0 0 0 0.243137 0 0 0 0 0.694118 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_191_2091"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.20293
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.858824 0 0 0 0 0.243137 0 0 0 0 0.694118 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_191_2091",
    result: "effect2_dropShadow_191_2091"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_191_2091",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.23996
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.858824 0 0 0 0 0.243137 0 0 0 0 0.694118 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_191_2091"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ddi_191_2091",
    x: 68.4211,
    y: 68.9613,
    width: 182.289,
    height: 179.523,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.3996
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_191_2091"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.20293
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_191_2091",
    result: "effect2_dropShadow_191_2091"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_191_2091",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.23996
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_191_2091"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ddi_191_2091",
    x: 53.7392,
    y: 21.4936,
    width: 242.509,
    height: 196.253,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.3996
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.172549 0 0 0 0 0.835294 0 0 0 0 0.768627 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_191_2091"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.20293
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.172549 0 0 0 0 0.835294 0 0 0 0 0.768627 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_191_2091",
    result: "effect2_dropShadow_191_2091"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_191_2091",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.23996
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.172549 0 0 0 0 0.835294 0 0 0 0 0.768627 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_191_2091"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ddi_191_2091",
    x: 22.8437,
    y: 131.175,
    width: 109.818,
    height: 147.962,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.3996
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.67451 0 0 0 0 0.309804 0 0 0 0 0.776471 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_191_2091"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.20293
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.67451 0 0 0 0 0.309804 0 0 0 0 0.776471 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_191_2091",
    result: "effect2_dropShadow_191_2091"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_191_2091",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.23996
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.67451 0 0 0 0 0.309804 0 0 0 0 0.776471 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_191_2091"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ddi_191_2091",
    x: 168.727,
    y: 209.125,
    width: 91.7621,
    height: 78.7082,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.3996
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.858824 0 0 0 0 0.243137 0 0 0 0 0.694118 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_191_2091"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.20293
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.858824 0 0 0 0 0.243137 0 0 0 0 0.694118 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_191_2091",
    result: "effect2_dropShadow_191_2091"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_191_2091",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.23996
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.858824 0 0 0 0 0.243137 0 0 0 0 0.694118 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_191_2091"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ddi_191_2091",
    x: 32.7028,
    y: 0.200844,
    width: 287.192,
    height: 262.274,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.3996
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.858824 0 0 0 0 0.243137 0 0 0 0 0.694118 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_191_2091"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.20293
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.858824 0 0 0 0 0.243137 0 0 0 0 0.694118 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_191_2091",
    result: "effect2_dropShadow_191_2091"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_191_2091",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.23996
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.858824 0 0 0 0 0.243137 0 0 0 0 0.694118 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_191_2091"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_ddi_191_2091",
    x: 0.887611,
    y: 121.097,
    width: 123.246,
    height: 180.508,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.3996
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.172549 0 0 0 0 0.835294 0 0 0 0 0.768627 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_191_2091"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.20293
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.172549 0 0 0 0 0.835294 0 0 0 0 0.768627 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_191_2091",
    result: "effect2_dropShadow_191_2091"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_191_2091",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.23996
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.172549 0 0 0 0 0.835294 0 0 0 0 0.768627 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_191_2091"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_ddi_191_2091",
    x: 48.0077,
    y: 44.2172,
    width: 225.358,
    height: 227.877,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.3996
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.67451 0 0 0 0 0.309804 0 0 0 0 0.776471 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_191_2091"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.20293
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.67451 0 0 0 0 0.309804 0 0 0 0 0.776471 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_191_2091",
    result: "effect2_dropShadow_191_2091"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_191_2091",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.23996
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.67451 0 0 0 0 0.309804 0 0 0 0 0.776471 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_191_2091"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoration);
export default __webpack_public_path__ + "static/media/decoration.4dbb0f775df0cc7b3dcbe67795c8cc4d.svg";
export { ForwardRef as ReactComponent };